import React, { Component } from 'react';
import {Link} from 'react-router-dom'

// 任务类型
export const typeMap = {
  signing: '10', // 标记中
  sign_checking: '20', // 标记审核中
  sign_rework: '21', // 标记返工
  sign_check_pass: '22', // 待插画(标记审核通过)
  icon_ing: '30', // 插画中
  icon_checking: '40', // 插画审核中
  icon_rework: '41', // 插画返工
  icon_check_pass: '42', // 题目待审核
  checking: '50', // 题目审核中
  finish: '60', // 任务完成
}

// 题目类型
export const questionTypeMap = {
  no_sign: '-1', // 未标记
  signing: '10', // 已标记
  sign_pass: '11', // 标记通过
  sign_rework: '12', // 标记返工
  sign_modify: '13', // 标记修改
  iconed: '20', // 已插画
  icon_pass: '21', // 插画通过
  icon_rework: '22', // 插画返工
  icon_modify: '23' // 画修改
}
//图片订正-tablist
export const tabList = [{
	name: '标记中',
	key: 'signing',
	index:0
}, {
	name: '标记审核中',
	key: 'sign_checking',
	index:1
}, {
	name: '标记返工',
	key: 'sign_rework',
	index:2
}, {
	name: '待插画',
	key: 'sign_check_pass',
	index:3
}, {
	name: '插画中',
	key: 'icon_ing',
	index:4
}, {
	name: '插画审核中',
	key: 'icon_checking',
	index:5
}, {
	name: '插画返工',
	key: 'icon_rework',
	index:6
}, {
	name: '题目待审核',
	key: 'icon_check_pass',
	index:7
}, {
	name: '题目审核中',
	key: 'checking',
	index:8
}, {
	name: '订正成功',
	key: 'finish',
	index:9
}]

//图片订正-列表
export const tableColumns = [{
  title: '任务ID',
  dataIndex:'task_id',
  key: 'task_id',
  width:100,
  index:1,
}, {
  title: '任务名',
  	dataIndex: 'name',
  	key: 'name',
  	width:300,
  	index:2,
  	render: (text, record) => {
  		return <a href={`#/questionmanage/imageCorrection/detail/${record.task_id}`} target='_blank'>{text}</a>;
  	}
}, {
  title: '任务名',
  	dataIndex: 'name',
  	key: 'name',
  	width:300,
  	index:3,
}, {
  title: '已标记/题量',
  key: 'question_sign_count/question_count',
  dataIndex: 'question_sign_count/question_count',
  width:100,
  index:4,
  render: (text, record, index) => {
            return <span>
                {record.question_sign_count}/ {record.question_count}
            </span>
      	}
}, {
  title: '通过/返工/题量',
  key: 'question_sign_pass_count/question_sign_rework_count/question_count',
  dataIndex: 'question_sign_pass_count/question_sign_rework_count/question_count',
  width:200,
  index:5,
  render: (text, record, index) => {
            return <span>
                {record.question_sign_pass_count}/{record.question_sign_rework_count}/ {record.question_count}
            </span>
      	}
},{
  title: '已改/返工/题量',
  key: 'question_sign_modify_count/question_sign_rework_count/question_count',
  dataIndex: 'question_sign_modify_count/question_sign_rework_count/question_count',
  width:150,
  index:6,
  render: (text, record, index) => {
            return <span>
                {record.question_sign_modify_count}/{record.question_sign_rework_count}/ {record.question_count}
            </span>
      	}
},{
  title: '题量',
  key: 'question_count',
  width:100,
  index:7,
  dataIndex: 'question_count',
},{
  title: '已画/合适/题量',
  key: 'question_icon_count/question_sign_suit_count/question_count',
  dataIndex: 'question_icon_count/question_sign_suit_count/question_count',
  width:200,
  index:8,
  render: (text, record, index) => {
            return <span>
                {record.question_icon_count}/{record.question_sign_suit_count}/ {record.question_count}
            </span>
      	}
},{
  title: '插画通过/合适/返工/题量',
  key: 'question_icon_pass_count/question_sign_suit_count/question_icon_rework_count/question_count',
  dataIndex: 'question_icon_pass_count/question_sign_suit_count/question_icon_rework_count/question_count',
  width:200,
  index:10, 
  render: (text, record, index) => {
            return <span>
                {record.question_icon_pass_count}/{record.question_sign_suit_count}/{record.question_icon_rework_count}/ {record.question_count}
            </span>
      	}
}, {
  title: '插画已改/合适/返工/题量',
  key: 'question_icon_modify_count/question_sign_suit_count/question_icon_rework_count/question_count',
  dataIndex: 'question_icon_modify_count/question_sign_suit_count/question_icon_rework_count/question_count',
  width:200,
  index:9,
  render: (text, record, index) => {
            return <span>
                {record.question_icon_modify_count}/{record.question_sign_suit_count}/{record.question_icon_rework_count}/ {record.question_count}
            </span>
      	}
},{
  title: '标记员',
  dataIndex: 'sign_user_name',
  width:100,
  index:11,
  key: 'sign_user_name',
},{
  title: '标记审核员',
  dataIndex: 'sign_check_user_name',
  width:100,
  index:12,
  key: 'sign_check_user_name',
}, {
  title: '标记截止时间',
  key: 'sign_dead_time',
  width:150,
  index:13,
  dataIndex: 'sign_dead_time',
},  {
  title: '标记完成时间',
  key: 'sign_finish_time',
  width:150,
  index:14,
  dataIndex: 'sign_finish_time',
},{
  title: '插画师',
  key: 'icon_user_name',
  width:100,
  index:15,
  dataIndex: 'icon_user_name',
},{
  title: '审核轮次',
  key: 'check_num',
  width:100,
  index:16,
  dataIndex: 'check_num',
},{
  title: '插画审核人',
  key: 'icon_check_user_name',
  width:100,
  index:17,
  dataIndex: 'icon_check_user_name',
},{
  title: '插画组长',
  key: 'icon_leader_name',
  width:100,
  index:18,
  dataIndex: 'icon_leader_name',
}, {
  title: '插画截止时间',
  key: 'icon_check_dead_time',
  width:150,
  index:19,
  dataIndex: 'icon_dead_time',
},{
  title: '插画审核完成时间',
  key: 'icon_check_finish_time',
  width:150,
  index:20,
  dataIndex: 'icon_check_finish_time',
},{
  title: '插画完成时间',
  key: 'icon_finish_time',
  width:150,
  index:21,
  dataIndex: 'icon_finish_time',
}, {
  title: '题目审核人',
  key: 'check_user_name',
  width:100,
  index:22,
  dataIndex: 'check_user_name',
},{
  title: '题目审核完成时间',
  key: 'finish_time',
  width:150,
  index:23,
  dataIndex: 'finish_time',
},{
  title: '任务创建时间',
  dataIndex: 'create_time',
  width:150,
  index:24,
  key: 'create_time',
}];

//分配人员标题
export const assgnModalTitleMapList=[{
	title:'分配标记员',
	key:'sign_user'
},{
	title:'分配标记审核员',
	key:'sign_check_user'
},{
	title:'分配插画师',
	key:'icon_user'
},{
	title:'分配插画审核员',
	key:'icon_check_user'
},{
	title:'分配插画师&插画审核员',
	key:'icon_and_check_user'
}]


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/image_correction/constData/index.js